"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
// import { ReactComponent as CheckedSvg } from "../images/icons/checked/checked-m.svg"
var CheckedM_1 = __importDefault(require("../icons/checked/CheckedM"));
var colors_1 = __importDefault(require("../style/colors"));
var mixins_1 = require("../style/mixins");
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var OuterBox = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  padding: 4px;\n  cursor: pointer;\n"], ["\n  display: inline-block;\n  padding: 4px;\n  cursor: pointer;\n"])));
var Box = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 24px;\n  height: 24px;\n  border-radius: 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ", "\n"], ["\n  width: 24px;\n  height: 24px;\n  border-radius: 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ",
    "\n"])), function (props) { return "\n  " + (props.checked ? "" : "border: 2px solid " + colors_1.default.primary.purple + ";") + "\n  background-color: " + (props.disabled
    ? colors_1.default.shade[4]
    : props.checked
        ? colors_1.default.primary.pink
        : colors_1.default.shade.white) + ";\n  "; });
var Input = styled_components_1.default.input.attrs({ type: "checkbox" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), mixins_1.invisible);
var CheckedIcon = styled_components_1.default(CheckedM_1.default)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: ", ";\n  visibility: ", ";\n"], ["\n  color: ", ";\n  visibility: ", ";\n"])), colors_1.default.shade.white, function (props) { return (props.visible ? "visible" : "hidden"); });
var Checkbox = function (props) {
    var checked = props.checked, id = props.id, className = props.className, disabled = props.disabled, children = props.children, onChange = props.onChange, onBlur = props.onBlur, name = props.name, noCheckViaLabel = props.noCheckViaLabel;
    var labelProps = { as: "label", htmlFor: id };
    return (react_1.default.createElement(Container, __assign({ className: className }, (noCheckViaLabel ? {} : labelProps)),
        react_1.default.createElement(OuterBox, __assign({}, (noCheckViaLabel ? labelProps : {})),
            react_1.default.createElement(Input, { id: id, checked: checked, disabled: disabled, onChange: onChange, onBlur: onBlur, name: name }),
            react_1.default.createElement(Box, { checked: checked, disabled: disabled },
                react_1.default.createElement(CheckedIcon, { visible: checked }))),
        children));
};
exports.default = Checkbox;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
